module.exports = __webpack_public_path__ + "img/mail.b24a00a3.svg";